import buildSlider from './slider';
// specify options here if needed and pass to buildSlider()
buildSlider('.slider-paragraph-featured-product-line');
